import React from "react";
import { useLocation, useParams } from "react-router-dom";

const Select = ({ handleChange, handleValue, element, loading, data }) => {
  const { id: filterId } = useParams();

  if (element.need && loading) {
    return <></>;
  }

  const renderOptions = () => {
    // console.log(element);
    // console.log(data);
    if (element.need) {
      return data.map(option => {
        if (element.filter) {
          return filterId != option.value ? <option value={option.value}>{option.label}</option> : null;
        }
        // else if (element.isCategory) {
        //   return <option value={option.id}>{option.description}</option>;
        // }
        else {
          return <option value={option.value}>{option.label}</option>;
        }
      });

    } else {
      return element.options.map(option => {
        return <option value={option.key}>{option.name}</option>;
      });
    }
  };
  // console.log("first", handleValue(element.key, element.nested));
  // if (!element.isCategory) {
    return (
      <div className="form-group my-3" >
        <div className="form-group">
          <label htmlFor="exampleSelectGender" className="pubLabel">{element.label}</label>
          <select
            onChange={({ target: { value } }) => {
              handleChange(element.key, value, element.nested);
            }}
            value={handleValue(element.key, element.nested)}
            className="form-control"
            id="exampleSelectGender"
          >
            <option>انتخاب کنید</option>
            {renderOptions()}
          </select>
        </div>
      </div>
    );
  // }
  // else {
  // }
};

export default Select;
